import { CalendarIcon, CurrencyDollarIcon, QueueListIcon, ScaleIcon } from '@heroicons/react/24/outline';
import { Journal, JournalOverview, JournalTaxTypeEnum } from '../../types/journal';
import { formatDateNumeric } from '../../utilities/formatting';
import JournalStatusBadge from '../../components/journal-status-badge/JournalStatusBadge';

type JournalDetailsProps = {
    journal: JournalOverview | Journal;
    showTaxExclAmount?: boolean;
    showStatus?: boolean;
};

function JournalDetails({ journal, showTaxExclAmount, showStatus }: JournalDetailsProps): JSX.Element {
    const accountsCount =
        'accounts' in journal ? journal.accounts.length : Array.from(new Set(journal.lines.map((line) => line.account?.id))).length;

    const taxTypes = showTaxExclAmount
        ? {
              [JournalTaxTypeEnum.NO_TAX]: 'Amounts do not include tax',
              [JournalTaxTypeEnum.EXCLUSIVE]: 'Amounts are tax exclusive',
              [JournalTaxTypeEnum.INCLUSIVE]: 'Amounts are tax exclusive',
          }
        : {
              [JournalTaxTypeEnum.NO_TAX]: 'No Tax',
              [JournalTaxTypeEnum.EXCLUSIVE]: 'Tax Exclusive',
              [JournalTaxTypeEnum.INCLUSIVE]: 'Tax Inclusive',
          };

    return (
        <div className="flex items-center gap-4 text-xs">
            {journal.status && showStatus && <JournalStatusBadge status={journal.status} />}
            <CalendarIcon className="text-gray-500 w-4 h-4" />
            <label className="text-gray-500 -ml-2">{journal.date ? formatDateNumeric(journal.date) : '-'}</label>
            {journal.taxType && (
                <>
                    <CurrencyDollarIcon className="text-gray-500 w-4 h-4" />
                    <label className="text-gray-500 -ml-2">{taxTypes[journal.taxType]}</label>
                </>
            )}
            <QueueListIcon className="text-gray-500 w-4 h-4" />
            <label className="text-gray-500 -ml-2">
                {journal.lines.length} {journal.lines.length !== 1 ? 'lines' : 'line'}
            </label>
            <ScaleIcon className="text-gray-500 w-4 h-4" />
            <label className="text-gray-500 -ml-2">
                {accountsCount} {accountsCount !== 1 ? 'accounts' : 'account'}
            </label>
        </div>
    );
}

export default JournalDetails;
